import type { LetterTemplate, LetterTemplateData } from './types';
import { DEFAULT_TEMPLATE_DATA } from './types';

export const TEMPLATES: LetterTemplate[] = [
  {
    id: 'classic_letter',
    label: 'Classic letter',
    description:
      'Formal letterhead with the agency block top-right and a sidebar QR. ' +
      'Best for owner-occupied detached / semi areas where a personal letter still wins.',
    format: 'letter',
    thumbnail: 'classic_letter',
    defaults: {
      ...DEFAULT_TEMPLATE_DATA,
      template_id: 'classic_letter',
      format: 'letter',
    },
  },
  {
    id: 'modern_letter',
    label: 'Modern letter',
    description:
      'Hero photo above a large coloured headline, short body, prominent CTA. ' +
      'Use when you have a strong recent-sale photo or a striking street shot.',
    format: 'letter',
    thumbnail: 'modern_letter',
    defaults: {
      ...DEFAULT_TEMPLATE_DATA,
      template_id: 'modern_letter',
      format: 'letter',
      headline: 'Your street just changed.',
      body:
        "A property near you in {{postcode}} sold recently — and the price might surprise you.\n\n" +
        "If you're even mildly curious what your home is worth right now, I can prepare a no-obligation valuation in 24 hours.",
      cta_text: 'Get your valuation in under 60 seconds.',
    },
  },
  {
    id: 'bold_postcard',
    label: 'Bold postcard',
    description:
      'A5 landscape postcard, double-sided. Photo + headline + QR on the front, ' +
      'short pitch and contact block on the back. Cheaper to post and impossible to ignore.',
    format: 'postcard',
    thumbnail: 'bold_postcard',
    defaults: {
      ...DEFAULT_TEMPLATE_DATA,
      template_id: 'bold_postcard',
      format: 'postcard',
      headline: 'Thinking of moving?',
      body:
        "I'm {{agent_name}} from {{agency_name}}. I sell homes on {{street}} and the surrounding streets every month — and right now buyers are paying more than you might think.\n\n" +
        "Scan the QR code for a free, no-obligation valuation.",
      cta_text: 'Free valuation — no calls unless you ask.',
      signature_line: '{{agent_name}}\n{{agency_name}}\n{{contact_phone}}',
    },
  },
];

export function findTemplate(id: string): LetterTemplate | undefined {
  return TEMPLATES.find((t) => t.id === id);
}

export function defaultDataFor(templateId: string): LetterTemplateData {
  const t = findTemplate(templateId) ?? TEMPLATES[0];
  return { ...t.defaults };
}

export * from './types';
